import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterNorma'
})
export class filterNorma implements PipeTransform {

    transform(data: any[], id: number) {
       // debugger;
        var dataNew = data.filter(array => array.tipo_id == id)
        return dataNew;
  }
}
